<!-- PFSPO selector dialog -->

<div *ngIf="mode == spoMode.popup" class="pfspo-selector-container" [ngStyle]="!dialog ? { width:'100%', height:'100%', border:'none' } : null">
  <!-- <div style="position:sticky;top:0.6em;margin-left:0.6em;margin-top:-1.5em;z-index:1;"> -->
  <div>
    <h4>PFSPO Selection</h4>
    <div class="header ml-2">
      <div style="display:ruby">
        <!-- <div style="position:absolute;top:0.6em;left:0.6em;z-index:1;"> -->
        <div><button class="nrk-button mr-2" (click)="close.emit()">close</button></div>
        <div><button class="nrk-button mr-2" (click)="clearFilter()">clear filter</button></div>
        <div class="mr-2">
          <ngx-doc-form-filter-select [(value)]="recipient" placeholder="Recipient" [options]="recipientOptions" (valueChange)="presort()"></ngx-doc-form-filter-select>
        </div>
        <div class="mr-2">
          <ngx-doc-form-filter-select [(value)]="accountManager" placeholder="AccountManager" [options]="employeeOptions" (valueChange)="presort()"></ngx-doc-form-filter-select>
        </div>
        <div class="mr-2">
          <!-- <ngx-doc-form-filter-select [(value)]="businessUnit" placeholder="BU" [options]="businessUnitOptions" (valueChange)="presort()"></ngx-doc-form-filter-select> -->
          <ngx-doc-form-dropdown [(value)]="businessUnit" placeholder="BU" [options]="businessUnitOptions" (valueChange)="presort()"></ngx-doc-form-dropdown>
        </div>
        <div class="mr-2">
          <button class="nrk-button" (click)="showSqm = (showSqm + 1) % 3">{{ ['pc', 'm²', 'm'][showSqm] }}</button>
        </div>
        <!-- <div class="mr-2">
          <ngx-doc-form-filter-select [(value)]="combinedShipment" placeholder="Combined shipment" [options]="combinedShipmentOptions" (valueChange)="presort()"></ngx-doc-form-filter-select>
        </div> -->
        <div><button class="nrk-button" (click)="transportFilter.stockNrka = !transportFilter.stockNrka; presort()">Stock NRKA <ng-container *ngIf="transportFilter.stockNrka">✓</ng-container></button></div>
        <div><button class="nrk-button" (click)="transportFilter.enRoute = !transportFilter.enRoute; presort()">En Route <ng-container *ngIf="transportFilter.enRoute">✓</ng-container></button></div>
        <div><button class="nrk-button mr-4" (click)="transportFilter.planned = !transportFilter.planned; presort()">Planned <ng-container *ngIf="transportFilter.planned">✓</ng-container></button></div>
        <!-- <button class="nrk-button" (click)="showAssignedPFSPOs=!showAssignedPFSPOs; filter()">{{showAssignedPFSPOs ? 'hide assigned PFSPOs' : 'show assigned PFSPOs'}}</button> -->
        <!-- </div> -->
        <!-- <div class="mr-4"><ngx-doc-form-checkbox label="not complete" [(value)]="showNotComplete" (valueChange)="filter()"></ngx-doc-form-checkbox></div>
        <div><ngx-doc-form-checkbox label="complete" [(value)]="showComplete" (valueChange)="filter()"></ngx-doc-form-checkbox></div> -->
        <div class="row">
          <div style="margin-top:0.2em">Availability:</div>
          <div style="position:relative;top:-0.4em;height:1em">
            <nb-radio-group name="availability" class="row ml-4" [(ngModel)]="availabilityStatus" (ngModelChange)="presort()">
              <nb-radio [value]="null">All</nb-radio>
              <nb-radio [value]="1">Partial avlbl.</nb-radio>
              <nb-radio [value]="2">Completed</nb-radio>
            </nb-radio-group>
          </div>
        </div>

        <div><button class="nrk-button ml-4 mr-2" (click)="downloadXlsx()">XLS</button></div>
        <div><button class="nrk-button ml-4 mr-2" (click)="downloadTimeline()">EM x SPO</button></div>
        <div><button class="nrk-button mx-2" [nbPopover]="colorLegend">Color legend</button></div>
        <ng-template #colorLegend>
          <div class="color-legend">
            <table class="nrk-table">
              <tr><th>Color</th><th>Status</th></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.unconfirmed }"></td><td>Unconfirmed</td></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.confirmedPlanned }"></td><td>Confirmed & Planned</td></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.confirmedEnRoute }"></td><td>Confirmed & En Route</td></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.fullyOnStock }"></td><td>Fully on Stock</td></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.partiallyAvailable }"></td><td>Partially Available</td></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.fullQAssigned }"></td><td>Full Q Assigned</td></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.completelyDelivered }"></td><td>Completely Delivered</td></tr>
              <tr><td [ngStyle]="{ 'background-color': colors.exception }"></td><td>Inventory Exception</td></tr>
            </table>
          </div>
        </ng-template>
        <div><ngx-document-finished-product-selector [multiselect]="true" [style]="{ right: 0 }"
            [businessId]="businessIdFilter" iconText="Product filter" (compilationChange)="finishedProductsChanged($event)">
          </ngx-document-finished-product-selector>
        </div>
        <div><button class="nrk-button mx-2" (click)="refreshData()">Refresh data <img *ngIf="cacheRefreshing" src="/assets/loading.png" style="width:20px;"/></button></div>
        <!-- <div style="width:30px;height:30px"><ngx-loading-spinner [loading]="cacheRefreshing"></ngx-loading-spinner></div> -->
      </div>
    </div>

    <!-- <div class="header-right">
      <div class="row">
      </div>
    </div> -->
    <pagination-controls (pageChange)="page = $event"></pagination-controls>
  </div>


  <div *ngIf="pfspoLineData?.length" class="select-comment"><div>Select 1 (PF)SPO<button class="nrk-button ml-2" (click)="clearFilter(true)">clear</button></div></div>
  <div class="table-div">
    <div *ngIf="!pfspoLineData?.length" style="padding-top:20rem">
      <ngx-loading-spinner [loading]="!pfspoLineData?.length"></ngx-loading-spinner>
    </div>
    <table *ngIf="pfspoLineData?.length">
      <thead style="height:6em">
        <tr>
          <th *ngIf="!hideStats"></th>
          <ng-container *ngFor="let col of columnOptions">
            <ng-container *ngIf="(showSqm && col['m2'] === showSqm) || (!showSqm && col['m2'] === 0) || col['m2'] === undefined">
              <th *ngIf="(!col['mode'] || col['mode'] == spoMode.popup)">
                <div class="column-header">
                  <!-- <div class="title"><a [routerLink]="" (click)="onSort(col.id)">{{col.name}}</a></div> -->
                  <div class="availability-sum">{{availabilitySum(col.id)}}</div>
                  <div class="title">
                    <a [routerLink]="[]" (click)="onSort(col)">{{col.name}}</a>
                    <span *ngIf="this.sort.col === col.id"> {{this.sort.dir > 0 ? '▲' : '▼'}}</span>
                  </div>
                  <div class="filter"><input placeholder="Search..." [(ngModel)]="col.search" (ngModelChange)="presort()"/></div>
                </div>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let spo of filteredSpos | paginate: { itemsPerPage: 10, currentPage: page }; index as idx">
          <!-- <tr (click)="save(spo)" [style.background-color]="spo.freeQ > 0 ? '#bfb' : null"> -->
          <tr (click)="save(spo)" [ngStyle]="getStyle(spo, true)">
            <td *ngIf="!hideStats"><button class="btn btn-default btn-sm" (click)="openPfspoChartWin(spo, idx);">
              <nb-icon icon="bar-chart-2"></nb-icon>
              <ngx-pfspo-charts [parent]="this" [selectedSpo]="spo"></ngx-pfspo-charts>
            </button></td>
            <ng-container *ngFor="let col of columnOptions">
              <ng-container *ngIf="(showSqm && col['m2'] === showSqm) || (!showSqm && col['m2'] === 0) || col['m2'] === undefined">
                <td *ngIf="col.id !== 'code' && !col['mode'] || col['mode'] == spoMode.popup" [ngStyle]="col.style">{{getText(spo, col)}}</td>
                <td *ngIf="col.id === 'code'">
                  <a [routerLink]="['/pages/erp/document/' + issuerData.get(spo.issuer)?.name.toLowerCase()]" [queryParams]="{code: spo.code}" target="_blank">
                    {{getText(spo, col)}}
                  </a>
                </td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>


<!-- associated PFSPO document table -->
<!-- <div *ngIf="mode > spoMode.popup" class="pfspo-selector-print">
  <table>
    <thead>
      <tr>
        <ng-container *ngFor="let col of columnOptions">
          <th *ngIf="col.mode != spoMode.newline">
            {{col.name}}
          </th>
        </ng-container>
      </tr>
    </thead>
    <ng-container *ngFor="let spo of pfspoLineData; index as idx">
      <tbody>
        <tr>
          <ng-container *ngFor="let col of columnOptions">
            <td *ngIf="col.mode != spoMode.newline && mode != spoMode.pdf && col.editable">
              <ngx-doc-form-texfield class="fullwidth" mode="integer"
                [value]="getText(spo, col)" (valueChange)="onDataChanged(idx, col.id, $event)" [disabled]="disabled"></ngx-doc-form-texfield>
            </td>
            <td *ngIf="col.mode != spoMode.newline && (mode == spoMode.pdf || !col.editable)" [ngStyle]="col.style">
              <a [ngStyle]="print && { 'text-decoration': 'none', 'color': 'black' }" *ngIf="col.id == 'code'" [routerLink]="['/pages/erp/document/' + issuer]"
                [queryParams]="{code: spo['code']}" >{{getText(spo, col)}}</a>
              <span *ngIf="col.id != 'code'">{{getText(spo, col)}}</span>
            </td>
          </ng-container>
        </tr>
        <ng-container *ngFor="let col of columnOptions">
          <tr *ngIf="col.mode == spoMode.newline"><td [ngStyle]="col.style" colspan="100">
            <ngx-form-text *ngIf="mode != spoMode.pdf" [multiline]="1" [value]="getText(spo, col)"
              (valueChange)="onDataChanged(idx, col.id, $event, spo)" [disabled]="disabled"></ngx-form-text>
            <div *ngIf="mode == spoMode.pdf">{{getText(spo, col)}}</div>
          </td></tr>
        </ng-container>
      </tbody>
    </ng-container>
  </table>
</div> -->
